module.exports = __webpack_public_path__ + "img/banner.7d326851.jpg";